<template>
  <div id="carouselExample" class="carousel slide">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <div id="banner01" class="bannerModulos">
          <div class="container px-4 px-lg-5 h-100">
            <div
              class="row gx-4 gx-lg-5 h-100 align-items-left justify-content-left text-left ml-4 container-escrita-banner">
              <div class="col-lg-8 align-self-end text-left">
                <!-- <h6 class="titulo-superior">INICIE HOJE MESMO</h6> -->
                <h6 class="title-principal text-white font-weight-bold">
                  Restultados:
                  <span>{{ this.$route.params.pesquisa }}</span>
                </h6> 
                <!-- <hr /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading" v-if="arrayPesquisa.length == 0 && !nenhumResultado">
      <div class="divLoading">
        <div class="spinner"></div>
        <span>Carregando...</span>
      </div>
    </div>
    <div class="" v-if="nenhumResultado">
      <div class="divLoading">
        <span style="margin-left: -170px; margin-top: 120px !important;">Nenhum resultado para: {{
          this.$route.params.pesquisa }}</span>
      </div>
    </div>
    <div class="divResultados" v-if="this.arrayPesquisa.length > 0 && !nenhumResultado">
      <div class="divResultadoPesquisa" v-for="(video, index) in arrayPesquisa" :key="index">
        <div class="d-flex" style="justify-content: space-between; align-items: center;">
          <div>
            <div class="tituloPesquisa">
              {{ video.titulo_video }}
            </div>
            <div class="descricaoPesquisa">
              {{ video.ds_video.substring(0, 70) }}...
            </div>
          </div>
          <div>
            <button class="btn btn-outline-light" @click="acessarVideo(video)">Acessar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  created() {
    this.carregarPesquisa()
  },
  watch: {
    '$route.params.pesquisa'(novoValor, antigoValor) {
      this.carregarPesquisa()
    }
  },
  data() {
    return {
      arrayPesquisa: [],
      nenhumResultado: true
    }
  },
  methods: {
    carregarPesquisa() {
      this.nenhumResultado = false
      this.arrayPesquisa = []
      this.$store.commit('videos/setPesquisa', true)

      this.$store.dispatch('modulos/getPesquisa', { pesquisa: this.$route.params.pesquisa }).then(response => {
        this.arrayPesquisa = response.data

        if (response.data.length == 0) {
          this.nenhumResultado = true
        }
      }).catch(e => {
        this.nenhumResultado = true
        this.arrayPesquisa = []
      }) 
    },
    acessarVideo(video){
      this.$router.push(`/video/${video.nr_seq_modulo}/${video.nr_sequencial}`)
    }
  }
};
</script>

<style lang="scss" src="./style.scss" scoped />
